var React = require('react');

function Width (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M41 128c55-40 113-40 175 0M41 58c55-40 113-40 175 0","stroke":"#2F73A7","strokeLinecap":"round","strokeWidth":"23","key":0}),React.createElement("text",{"fill":"#0D3B5E","fontFamily":"Arial","fontSize":"200","x":"30","y":"260","key":1},"↔")]);
}

Width.defaultProps = {"viewBox":"0 0 256 256","width":"32"};

module.exports = Width;

Width.default = Width;
